import React, { Component } from 'react'
import PropTypes from 'prop-types'

import moment from 'moment'
import _ from 'lodash'

import { DEFAULT_PRECISION_FORMATS, DEFAULT_PRECISION } from './constants'

export default class CustomDate extends Component {
    static propTypes = {
        customStyle: PropTypes.object,
        date: PropTypes.string,
        precision: PropTypes.string,
        precisionFormats: PropTypes.object,
        returnType: PropTypes.string,
    }

    static defaultProps = {
        customStyle: {},
        precision: DEFAULT_PRECISION,
        precisionFormats: DEFAULT_PRECISION_FORMATS,
    }

    render() {
        const { date, precision, precisionFormats, customStyle, returnType = null } = this.props

        switch (returnType) {
            case 'data':
                return date && moment(date).format(_.get(precisionFormats, precision, DEFAULT_PRECISION))
            default:
                return (
                    <span className={'custom-date'} style={customStyle}>
                        {date && moment(date).format(_.get(precisionFormats, precision, DEFAULT_PRECISION))}
                    </span>
                )
        }
    }
}
